/**
 * Lawyer API Service
 */

import { apiRequest } from "../../api/apiClient";
import type {
  Lawyer,
  CreateLawyerDto,
  UpdateLawyerDto,
} from "../../types/lawyer.types";

const handleResponse = async (response: Response) => {
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || errorData || "API request failed");
  }
  const contentType = response.headers.get("content-type");
  if (contentType && contentType.includes("application/json")) {
    return response.json();
  }
  return null;
};

export const lawyerService = {
  getLawyersByApplicationId: async (
    certificateApplicationId: number,
  ): Promise<Lawyer[]> => {
    const response = await apiRequest(
      `/Lawyers/certificate-application/${certificateApplicationId}`,
      { method: "GET" },
    );
    return handleResponse(response);
  },

  createLawyer: async (dto: CreateLawyerDto): Promise<Lawyer> => {
    const response = await apiRequest("/Lawyers", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
    return handleResponse(response);
  },

  updateLawyer: async (id: number, dto: UpdateLawyerDto): Promise<Lawyer> => {
    const response = await apiRequest(`/Lawyers/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(dto),
    });
    return handleResponse(response);
  },

  deleteLawyer: async (id: number): Promise<void> => {
    const response = await apiRequest(`/Lawyers/${id}`, {
      method: "DELETE",
    });
    return handleResponse(response);
  },
};
